import ExternalImageLink from './Still_External';

export default ExternalImageLink;
